// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title {
  color: var(--foreground);
}

.modal-body {
  color: var(--foreground);
}

.color-div {
  position: "absolute";
  z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/management/projectManagement/styles/popup.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ","sourcesContent":[".modal-title {\n  color: var(--foreground);\n}\n\n.modal-body {\n  color: var(--foreground);\n}\n\n.color-div {\n  position: \"absolute\";\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
